import React from 'react'
import wa from '../assets/btn_WhatsApp.png'

const BotWhatsapp = () => {
    return (
        <div>
            <p href='http://api.whatsapp.com/send?1=pt_BR&phone=5511954209626'>
                <img className=' animation-ronsof-five lg:my-auto' src={wa} alt='whatsapp' />
            </p>
        </div >
    )
}
export default BotWhatsapp

